NATIVE_SYMBOL_REGISTRY